import radio from "@/components/Common/CustomRadio/CustomRadio.vue";

const CustomRadio = {
  install: function (Vue) {
    Vue.component('customRadio', radio);
  }
}
export default CustomRadio;